module.exports = __webpack_public_path__ + "img/5.f625b53.jpg";